import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { DeclaracionSuplementariaService } from '../declaracionsuplementaria.service';
import { FilterSearchingTDeclaracionSuplementariaViewModel, DeclaracionSuplementariaItemResultsViewModel } from '../declaracionsuplementaria.types';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';

@Component({
    selector: 'app-declaracionsuplementaria-wrapper',
    templateUrl: './declaracionsuplementaria-wrapper.component.html',
    styleUrls: ['./declaracionsuplementaria-wrapper.component.scss'],
})
export class DeclaracionSuplementariaWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: DeclaracionSuplementariaItemResultsViewModel | null;
    payload?: FilterSearchingTDeclaracionSuplementariaViewModel;
    edition = false;

    listCampanias: Tc[];
    listPais: Tc[];

    listCampanias$ = this.globalService.getAllCampanias().subscribe(params => {
        this.listCampanias = params;
    });

    listPais$ = this.globalService.getAllPaises().subscribe(params => {
        this.listPais = params;
    });

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private declaracionSuplementariaService: DeclaracionSuplementariaService,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.recoverLastSearch();
    }

    onSearch(payload: FilterSearchingTDeclaracionSuplementariaViewModel): void {
        if (!payload) {
            return;
        }

        this.payload = { ...payload } as FilterSearchingTDeclaracionSuplementariaViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.declaracionSuplementariaService.getDeclaracionesSuplementarias(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingTDeclaracionSuplementariaViewModel;
        this.onSearch(payload);
    }

    onReset(): void {
        this.searching = false;
        this.result = null;
        this.declaracionSuplementariaService.clearLastSearch();
    }

    onAdd(): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/general/declaracionsuplementaria/create']);
    }

    onEdit(itemId: number | null): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/general/declaracionsuplementaria/edit', itemId]);
    }

    private recoverLastSearch() {
        this.payload = this.declaracionSuplementariaService.getLastSearch();
    }

    onClone(itemId: number): void {
        this.declaracionSuplementariaService.getCloneDeclaracionSuplementaria(itemId).subscribe(idDeclaracionSup => {
            if (idDeclaracionSup != null) {
                this.addSuccessMessage('Declaración Suplementaria clonada correctamente');
                this.router.navigate(['/mantenimiento/general/declaracionsuplementaria/edit', idDeclaracionSup]);
            } else {
                this.addErrorMessage('Error al clonar la Declaración Suplementaria');
            }
        });
    }
}
